// TODO cleanup
// import { formatDate } from '@axo/deprecated/util/ui-components/utils/format-date';
import { Formatters } from '@axo/shared/util/string';
import { DebtEntriesTexts, Loan } from './Loan';

export function formatCurrency(value: number) {
  return `${Formatters.formatNumber(value, ' ')} kr`;
}

export function formatInterest(value: number) {
  return `${value} %`;
}

/** DIRTY dump of legacy */
interface IFormatNumberOptions {
  minLength: number;
}
const formatNumber = (
  value: number | undefined,
  { minLength }: IFormatNumberOptions = { minLength: 0 }
) => {
  if (value === undefined) return '';

  let out = value.toString();

  while (out.length < minLength) {
    out = '0' + out;
  }

  return out;
};

export const formatDate = (date: Date | undefined, format: string) =>
  format
    .replaceAll('[yyyy]', formatNumber(date?.getFullYear()))
    .replaceAll(
      '[MM]',
      formatNumber(date ? date.getMonth() + 1 : undefined, { minLength: 2 })
    )
    .replaceAll('[dd]', formatNumber(date?.getDate(), { minLength: 2 }))
    .replaceAll('[hh]', formatNumber(date?.getHours(), { minLength: 2 }))
    .replaceAll('[mm]', formatNumber(date?.getMinutes(), { minLength: 2 }));

/** END DIRTY dump of legacy */

export function formatDateString(dateString: string) {
  return formatDate(new Date(dateString), '[dd].[MM].[yyyy]');
}

export function getInstallmentPeriodText(installmentChargePeriod: string) {
  switch (installmentChargePeriod) {
    case 'MONTHLY':
      return 'Månedlig';
    case 'QUARTERLY':
      return 'Kvartalsvis';

    default:
      return installmentChargePeriod;
  }
}

export function getCoBorrowerTexts(coBorrowerCode: string) {
  switch (coBorrowerCode) {
    case '0':
      return 'Nei';
    case '1':
      return 'Ja';
    case '2':
      return 'Ja';

    default:
      return coBorrowerCode;
  }
}

export function formatDebtType(type: string) {
  switch (type) {
    case 'repaymentLoan':
      return 'Repayment Loan';

    case 'creditFacility':
      return 'Credit Facility';

    case 'chargeCard':
      return 'Charge Card';

    default:
      return type;
  }
}

type DebtDetails = {
  headerDetails: { [key: string]: string };
  expandedDetails: { [key: string]: string };
};

export function getDebtDetails({ debt, labels }: Loan): DebtDetails {
  let headerDetails = {
    [labels.nonInterestBearingDebt]: formatCurrency(
      debt.nonInterestBearingBalance
    ),
    [labels.interestBearingDebt]: formatCurrency(debt.interestBearingBalance),
  };

  const expandedDetails = {
    [labels.creditType]:
      labels?.[debt.type as keyof DebtEntriesTexts] ??
      formatDebtType(debt.type),
    [labels.creditLimit]: formatCurrency(debt.creditLimit),
    [labels.nominalInterest]: formatInterest(debt.nominalInterestRate),
    [labels.installmentCharges]: formatCurrency(debt.installmentCharges),
    [labels.installmentChargePeriod]: getInstallmentPeriodText(
      debt.installmentChargePeriod
    ),
    [labels.processedTime]: formatDateString(debt.processedTime),
    [labels.receivedTime]: formatDateString(debt.receivedTime),
    [labels.coBorrower]: getCoBorrowerTexts(debt.coBorrower),
  };

  if (debt.type === 'repaymentLoan') {
    headerDetails = {
      [labels.originalBalance]: formatCurrency(debt.originalBalance),
      [labels.remainingBalance]: formatCurrency(debt.balance),
    };
  }

  return {
    headerDetails,
    expandedDetails,
  };
}
